<div class="sidenav-body-content subscription">
  <router-outlet></router-outlet>
  <app-custom-notifications></app-custom-notifications>
</div>
